// extracted by mini-css-extract-plugin
module.exports = {"menu":"LanguageSelect_menu__3kepV","menuItem":"LanguageSelect_menuItem__utGbn","triggeredContent":"LanguageSelect_triggeredContent__jOMEj"};